import { Navigate } from '@sorare/routing';
import { ANY_SPORT_SERIES_ONBOARDING_SELECT_COMPETITION } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';

const LegacySelectCompetitionPage = () => {
  const { generateSportContextPath } = useSportContext();
  return (
    <Navigate
      to={generateSportContextPath(
        ANY_SPORT_SERIES_ONBOARDING_SELECT_COMPETITION
      )}
      keepSearchParams
      replace
    />
  );
};

export default LegacySelectCompetitionPage;
